export default "__VITE_ASSET__CFMXnDoC__"